<app-ip-tab-panel #tabPanel id='tab-panel'>
  <app-ip-tab #loginTab [title]='"Login"'>
    <form action=''>
      <div class='form-field'>
        <label for='email'>Email</label><input class='login-email' id='email'>
      </div>
      <div class='form-field'>
        <label for='password'>Password</label><input id='password'>
      </div>
    </form>
  </app-ip-tab>
  <app-ip-tab #signUpTab [title]='"Sign up"'>
    <form action=''>
      <div class='form-field'>
        <label for='email-signup'>Email</label><input id='email-signup'>
      </div>
      <div class='form-field'>
        <label for='password-signup'>Password</label><input id='password-signup'>
      </div>
      <div class='form-field'>
        <label for='password-confirmation'>Confirmation</label><input id='password-confirmation'>
      </div>
    </form>
  </app-ip-tab>
  <app-ip-tab [selected]='true' [title]='"Contact"'>
    <form action=''>
      <div class='form-field'>
        <label for='email-contact'>Email</label><input class='contact-email' id='email-contact'>
      </div>
      <div class='form-field'>
        <label for='message'>Message</label><textarea id='message'></textarea>
      </div>
    </form>
  </app-ip-tab>
</app-ip-tab-panel>
